
function handleize(str) {
  if (!str) {
    return '';
  }
  str = str.toLowerCase();
  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }
  str = str.replace(/\W+/g, "-");
  if (str.charAt(str.length - 1) == "-") {
    str = str.replace(/-+\z/, "");
  }
  if (str.charAt(0) == "-") {
    str = str.replace(/\A-+/, "");
  }
  return str
};
window.addEventListener('DOMContentLoaded', function() {
  var allTabBtns = document.querySelectorAll('.pdp-section__toggle');
  if (allTabBtns.length) {
    allTabBtns.forEach((button) => {
      button.addEventListener('click', function () {
        button.classList.toggle('active-mobile');
        if (button.classList.contains('active-mobile')) {
          button.nextElementSibling.style.maxHeight = button.nextElementSibling.scrollHeight + 'px';
        } else {
          button.nextElementSibling.style.maxHeight = '0px';
        }
      });
    });
  }
  window.onresize = function () {
    if (window.innerWidth >= 750) {
      document.querySelectorAll('.pdp-section__content').forEach(c => {
        c.removeAttribute("style");
      });
    }
  };
});
var sectionsLoaded = false;
function scroll_pdp(el) {
  if(!sectionsLoaded){
    $('html, body').animate({
      'scrollTop': window.scrollY + 100
    }, 500);
    if(typeof renderRecommendations !== 'undefined'){
      renderRecommendations(document.querySelector('product-recommendations'));
    } else {
      sectionsLoaded = true;
    }
    setTimeout(function () { scroll_pdp(el); }, 500);
    return;
  }
  var section = '.'+$(el).attr('data-section-class');
  var scroll_to = $(section).offset().top;
  // if(scroll_to < window.scrollY){
  //   scroll_to = scroll_to - $('#theme-header').height()
  // }
  $('html, body').animate({
    'scrollTop': scroll_to - $('.pdp-sticky-nav').height()
  }, 400);
}
window.addEventListener('DOMContentLoaded', function () {
  $('.pdp-sticky-nav').parent().css('position', 'sticky').css('top', '0').css('z-index', '10').css('background-color', 'white');
  $('.pdp-sticky-nav__item').on('click', function (e) {
    e.preventDefault();
    var el = this;
    if ($('.slider-container:not(.swiper-container-initialized)').length > 0) {
      window.dispatchEvent(new CustomEvent('scroll'));
    }
    scroll_pdp(el);
  });
  var mainNavLinks = document.querySelectorAll(".pdp-sticky-nav__item");
  window.addEventListener("scroll", UpdateStickyNav);
  //only update sticky nav on scroll every 100 ms to avoid excessive updates
  function UpdateStickyNav() {
    var topOfWindow = window.scrollY + $('.pdp-sticky-nav').outerHeight() - 1; //sticky nav is 64 pixels
    var bottomOfWindow = window.scrollY + window.innerHeight;
    for (var i = 0; i < mainNavLinks.length; i++) {
      if (!$(mainNavLinks[i]).attr('data-section-class') || $(mainNavLinks[i]).attr('data-section-class').length == 0) {
        $(mainNavLinks[i]).remove();
        continue;
      }
      try {
        var section = document.querySelector('.' + $(mainNavLinks[i]).attr('data-section-class'));
      } catch {
        $(mainNavLinks[i]).remove();
        continue;
      }
      if (section == null) {
        $(mainNavLinks[i]).remove();
        continue;
      }
      mainNavLinks = document.querySelectorAll(".pdp-sticky-nav__item");
      var topOfSection = section.offsetTop;
      var bottomOfSection = section.offsetTop + section.offsetHeight;
      //mark tabs active for sections completely in viewport
      if (
        topOfSection > topOfWindow && bottomOfSection < bottomOfWindow
      ) {
        $(mainNavLinks[i]).addClass('active');
      } else {
        $(mainNavLinks[i]).removeClass('active');
      }
    }
    if ($('.pdp-sticky-nav .active').length == 0) {
      //If no info sections are completely in viewport, mark active the section containing top of viewport
      $('.pdp-section').each(function () {
        var topOfSection = $(this).offset().top;
        var bottomOfSection = $(this).offset().top + $(this).outerHeight();
        if (topOfSection <= topOfWindow && bottomOfSection >= topOfWindow) {
          var section_name = $(this).attr('data-section-name');
          $('[data-section-class="' + section_name + '"]').addClass('active');
          return false;
        }
      });
    } else {
      //only highlight first section if two are sections are highlighted (both within viewport)
      $('.pdp-sticky-nav__item.active').each(function (index) {
        if (index != 0) {
          $(this).removeClass('active');
        }
      });
    }
    var sample_button = setInterval(() => {
      if (document.querySelector('.pdp-sticky-button') != null) {
        clearInterval(sample_button);
        
        //console.log(document.querySelector(".sample__button").disabled);
        //if (document.querySelector('.sample__button') && document.querySelector('.sample__button').classList.contains('active')) {
          //document.querySelector('.pdp-sticky-button').disabled = false;
         // document.querySelector('.pdp-sticky-button').style.display = 'flex';
        //} else {
        //  document.querySelector('.pdp-sticky-button').disabled = true;
        //  document.querySelector('.pdp-sticky-button').style.display = 'none';
       // }

        

        if(document.querySelector('.sample__button')){
          if (document.querySelector('.sample__button').classList.contains('active') && document.querySelector(".sample__button").disabled == true) {
            document.querySelector('.pdp-sticky-button').disabled = true;
            document.querySelector('.pdp-sticky-button').style.display = 'none';
          } else {
            document.querySelector('.pdp-sticky-button').disabled = false;
            document.querySelector('.pdp-sticky-button').style.display = 'flex';
          }
        }else{
            document.querySelector('.pdp-sticky-button').disabled = true;
            document.querySelector('.pdp-sticky-button').style.display = 'none';
        }
        
      }
    }, 100);
  };
  UpdateStickyNav();
  if(mainNavLinks.length < 2) {
    $('.pdp-sticky-nav').hide();
  }
  $('.pdp-sticky-button').click(function () {
    pdp_vue.addSampleToCart();
  });
});
// function adjustPDPNav() {
//   var times = 0;
//   var i = setInterval(function () {
//     if ($('.header-hidden').length < 1) {
//       $('.pdp-sticky-nav').parent().css('top', $('.header-sticky').height() + 'px');
//     } else {
//       $('.pdp-sticky-nav').parent().css('top', '0px');
//     }
//     times++;
//     if (times > 5) {
//       clearInterval(i);
//     }
//   }, 100)
// }
